import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { PtsPaymentTerminal, TerminalSessionResponse, TerminalSessionSearchEvent } from '../../pts-payment-terminal-model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PtsPaymentTerminalService } from 'src/app/shared/services/payment-terminal.service';
import { SnackbarService } from 'ok-angular-shared/components';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PagingOptions } from 'src/app/shared/models/paging';
import { AppState } from 'src/app/app.state';
import { Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { LoadingSpinnerComponent } from '../../../../../core/loading-spinner/loading-spinner.component';
import { PagerBase } from 'src/app/shared/models/pagerBase';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'adm-terminal-sessions',
  templateUrl: './terminal-sessions-dialog.component.html',
  styleUrl: './terminal-sessions-dialog.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  imports: [
    LoadingSpinnerComponent,
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
  ],
})
export class TerminalSessionsDialogComponent extends PagerBase implements OnInit, OnDestroy {
  dialogRef = inject<MatDialogRef<TerminalSessionsDialogComponent>>(MatDialogRef);
  data = inject<{
    paymentTerminal: PtsPaymentTerminal;
  }>(MAT_DIALOG_DATA);
  private ptsPaymentTerminalService = inject(PtsPaymentTerminalService);
  private snackbarService = inject(SnackbarService);
  appState = inject(AppState);

  @ViewChild(MatTable) public terminalSessionList: MatTable<TerminalSessionResponse>;
  @ViewChild(MatPaginator) public paginator: MatPaginator;
  paymentTerminal: PtsPaymentTerminal;
  expandedTerminalSession: TerminalSessionResponse | null;
  terminalSessionSearchEvent: TerminalSessionSearchEvent;
  terminalSessions: TerminalSessionResponse[] = [];
  actionLogCount: number;
  currentPage: number;
  pagingOptions: PagingOptions;
  displayColumns = ['updated', 'status', 'payterSessionId', 'chargingToken', 'commitTimestamp', 'actions'];

  data$: BehaviorSubject<TerminalSessionResponse[]>;
  dataSource: MatTableDataSource<TerminalSessionResponse> = new MatTableDataSource<TerminalSessionResponse>();
  terminalSessionCount: number;
  terminalSessionsSubscription: Subscription;
  public loading$ = new BehaviorSubject<boolean>(false);
  ngOnInit(): void {
    this.pagingOptions = {
      pageSize: this.defaultPageSize,
      pageSizeOptions: this.pageSizes,
    };
    this.paymentTerminal = this.data.paymentTerminal;
    this.terminalSessionSearchEvent = {
      serialNumber: this.paymentTerminal.serialNumber,
      query: null,
      paging: new PageEvent(),
    };

    this.getTerminalSessions();
  }

  private async getTerminalSessions() {
    this.loading$.next(true);
    this.terminalSessionsSubscription = this.ptsPaymentTerminalService.getTerminalSessions(this.terminalSessionSearchEvent).subscribe({
      next: sessions => {
        this.dataSource.data = sessions.items;
        this.terminalSessionCount = sessions.totalCount;
        this.data$ = this.dataSource.connect();

        if (this.terminalSessionCount !== this.paginator?.length && this.paginator != null) {
          this.paginator.pageIndex = 0;
        }
        this.loading$.next(false);
      },
      error: err => {
        this.snackbarService.error(err?.error.message);
        this.loading$.next(false);
      },
    });
  }

  public close() {
    this.dialogRef.close();
  }

  public pageSwitch(event: PageEvent) {
    this.terminalSessionSearchEvent.paging = event;
    this.getTerminalSessions();
  }

  public sortData(event: Sort) {
    if (this.terminalSessionSearchEvent.paging) {
      this.terminalSessionSearchEvent.paging.pageIndex = 0;
    }
    if (!event.direction) {
      event.active = '';
    }
    this.terminalSessionSearchEvent.sorting = event;
    this.getTerminalSessions();
  }

  ngOnDestroy(): void {
    if (this.dataSource) {
      this.dataSource.disconnect();
    }

    if (this.terminalSessionsSubscription) {
      this.terminalSessionsSubscription.unsubscribe();
    }
  }
}
